import { createContext } from 'react'

export const ViewModeContext = createContext({ isPreview: false, isReview: false } as {
  isPreview?: boolean
  isReview?: boolean
})

type ViewModeProviderProps = {
  children?: React.ReactNode
  isPreview?: boolean
  isReview?: boolean
}

export const ViewModeProvider = ({ children, isPreview, isReview }: ViewModeProviderProps) => (
  <ViewModeContext.Provider value={{ isPreview, isReview }}>{children}</ViewModeContext.Provider>
)
